import { Bff } from 'core/services';

export const paymentsNewFlow: string[] = [
  Bff.PAYMENT_PLAN_TYPE.BANK_BILLING,
  Bff.PAYMENT_PLAN_TYPE.PIX,
  Bff.PAYMENT_PLAN_TYPE.PIX_PAYMENT,
  Bff.PAYMENT_PLAN_TYPE.BANK_SLIP,
  Bff.PAYMENT_PLAN_TYPE.OTHER,
  Bff.PAYMENT_PLAN_TYPE.CENTRAL_PAYMENT,
];
